import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import { CertidoesAno } from "@/types/interno/certidoes-ugs/certidoes-ano";
import {
  BaseLegal,
  BaseLegalJson,
} from "@/types/interno/certidoes-ugs/base-legal";

import {
  BaseLegalPendente,
  BaseLegalPendenteJson,
} from "@/types/interno/certidoes-ugs/base-legal-pendente";

import { Certidao } from "@/types/interno/certidoes-ugs/certidao";

const certidoesPath = process.env.VUE_APP_ENTREGAS_API + "/Certidao";

const certidoesUgService = {
  buscarBasesLegais,
  buscarDadosUg,
  buscarUGs,
  salvarItem,
  editarItem,
  validarBasesLegais,
};

async function buscarBasesLegais(ug: string): Promise<BaseLegal[]> {
  const url = `${certidoesPath}/baseslegais/${ug}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200)
    return response.data.map((item: BaseLegalJson) => new BaseLegal(item));
  console.error("Falha ao buscar bases legais da UG", url, response);
  throw new PortalError("Falha ao buscar bases legais da UG");
}

async function validarBasesLegais(ug: string): Promise<any[]> {
  const url = `${certidoesPath}/dados/${ug}/validar`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200)
    return response.data.map(
      (item: BaseLegalPendenteJson) => new BaseLegalPendente(item)
    );
  console.error("Falha ao validar bases legais da UG", url, response);
  throw new PortalError("Falha ao validar bases legais da UG");
}
async function buscarDadosUg(codigoUG: string): Promise<CertidoesAno[]> {
  const url = `${certidoesPath}/dados/${codigoUG}`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200)
    return response.data.map((ca: any) => new CertidoesAno(ca));
  console.error("Falha ao buscar dados da UG para certidoes", url, response);
  throw new PortalError("Falha ao buscar dados da UG para certidoes");
}
async function buscarUGs(): Promise<UnidadeGestoraResumida[]> {
  const url = `${certidoesPath}/ugs`;
  const response = await Service.$http.get(url);
  if (response && response.status === 200)
    return response.data.map((ug: any) => new UnidadeGestoraResumida(ug));
  console.error("Falha ao buscar UGs para certidoes", url, response);
  throw new PortalError("Falha ao buscar UGs para certidoes");
}

async function salvarItem(
  cert: Certidao,
  ug: string,
  exercicio: number
): Promise<BaseLegalPendente[]> {
  const data = {
    baselegal: cert.IdBaseLegal,
    resultado: cert.Resultado,
    detalhamento: cert.Detalhamento,
    fonte: cert.Fonte,
  };
  const url = `${certidoesPath}/dados/${ug}/${exercicio}`;
  const response = await Service.$http.post(url, data);
  if (response && response.status === 200) {
    return response.data;
  }
  console.error("Falha ao salvar item de certidao", url, cert, response);
  throw new PortalError("Falha ao salvar item de certidao");
}

async function editarItem(
  cert: Certidao,
  idItem: number
): Promise<BaseLegalPendente[]> {
  const data = {
    baselegal: cert.IdBaseLegal,
    resultado: cert.Resultado,
    detalhamento: cert.Detalhamento,
    fonte: cert.Fonte,
  };
  const url = `${certidoesPath}/dados/${idItem}`;
  const response = await Service.$http.patch(url, data);
  if (response && response.status === 200) {
    return response.data.map(
      (item: BaseLegalPendenteJson) => new BaseLegalPendente(item)
    );
  }
  console.error("Falha ao editar item de certidao", url, cert, response);
  throw new PortalError("Falha ao editar item de certidao");
}

export default certidoesUgService;
